import { withInstall as t } from "../../utils/with-install.js";
import o from "./overlay.vue.js";
/* empty css             */
const i = t(o);
export {
  i as ApOverlay,
  i as default
};
